import { Ass_01, Exp_01 } from "../../Chart.js";
import { NewEntry } from "../../entry/NewEntry.js";
import { Template } from "../../template/Template.js";
import { findVariableValue } from "../../template/findVariableValue.js";

export const HEALTH_SUPPORT: Template = {
  id: "b949d033-8d5f-4ea4-84e6-acd563fcb640",
  name: "Tervisetoetus kassast",
  variables: [
    {
      name: "Title",
      type: "text"
    },
    {
      name: "Date",
      type: "date"
    },
    {
      name: "Amount",
      type: "amount_eur"
    }
  ],
  initialValues: [
    {
      name: "Title",
      value: "Tervisetoetus: "
    }
  ],
  generate: (values) => {
    const date = findVariableValue("Date", values);
    const amount = Math.round(parseFloat(findVariableValue("Amount", values)) * 100);

    const entry: NewEntry = {
      title: findVariableValue("Title", values),
      items: [
        {
          title: "Tervisetoetus",
          date: date,
          amount: amount,
          eurAmount: amount,
          currency: "eur",
          debit: Exp_01,
          credit: Ass_01
        }
      ]
    };

    return { type: "success", entry };
  }
};
